import NewList_grid from "../images/NewList_grid.png";
import NewList_2 from "../images/NewList_2.png";
import NewList_3 from "../images/NewList_3.png";
import D_NewList_grid from "../images/D_NewList_grid.png";

export const thirdEN = [
    {
        title1: 'A Variety of Labels',
        subtitle1: "Text labels, color labels, star labels.",
        subtitle2: "Group your notes differently.",
        img: {NewList_grid},
        img_uri: "../images/NewList_grid.png"
    },
    {
        title1: "Easy to Use Checklists",
        subtitle1: "Add, delete, and change the ",
        subtitle2: "order of your checklists.",
        img: {NewList_2},
        img_uri: "../images/NewList_2.png"
    },
    {
        title1: "Manage Text Labels",
        subtitle1: "Saved text labels can ",
        subtitle2: "group your notes into tabs.",
        img: {NewList_3},
        img_uri: "../images/NewList_3.png"
    },
    {
        title1: "Dark Mode",
        subtitle1: "With dark mode support, ",
        subtitle2: "you can freely use Vanilla Note.",
        img: {D_NewList_grid},
        img_uri: "../images/D_NewList_grid.png"
    },
];